var map = {
	"./logo_GI_blu_de.png": "./src/assets/logo_GI_blu_de.png",
	"./logo_GI_blu_en.png": "./src/assets/logo_GI_blu_en.png",
	"./logo_GI_blu_es.png": "./src/assets/logo_GI_blu_es.png",
	"./logo_GI_blu_it.png": "./src/assets/logo_GI_blu_it.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets sync recursive ^\\.\\/logo_GI_blu_.*\\.png$";